// Badge text for a connected account on the org's Connected integrations list.
// No React and no api client at runtime, so `node --test` covers it.

/** "All Boos" when any binding is org-wide, else how many Boos it is bound to. */
export function accountUsageLabel(bindings: readonly { containerId: string | null }[]): string {
  if (bindings.some((b) => b.containerId === null)) return "All Boos";
  const booCount = new Set(bindings.map((b) => b.containerId)).size;
  return booCount === 0 ? "Not in use" : booCount === 1 ? "1 Boo" : `${booCount} Boos`;
}
